import { render, staticRenderFns } from "./Piezas.vue?vue&type=template&id=fa0c7386&"
import script from "./Piezas.vue?vue&type=script&lang=js&"
export * from "./Piezas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports